export default function complaintsForm() {
    const FORM_ID = 86436;

    document.addEventListener('wpcf7mailsent', function(event) {
        if (event.detail.contactFormId != FORM_ID) return;

        const inputs = event.detail.inputs;
        const getValue = name => (inputs.find(i => i.name === name) || {}).value || '';

        const feedbackType = getValue('feedback-type');
        const dpaComplaint  = getValue('dpa-complaint');

        const confirmation = document.getElementById('complaints-confirmation');
        if (!confirmation) return;

        const isComplaint = feedbackType === 'Complaint';
        const isDpa = isComplaint && dpaComplaint === 'Yes';

        // Set state on every submission so a second submission on the same page
        // doesn't leave the previous message showing alongside the new one.
        confirmation.toggleAttribute('hidden', !isComplaint);
        document.getElementById('complaints-msg-dpa').toggleAttribute('hidden', !isDpa);
        document.getElementById('complaints-msg-general').toggleAttribute('hidden', isDpa || !isComplaint);
        document.getElementById('complaints-msg-who-else').toggleAttribute('hidden', !isComplaint);

        if (!isComplaint) return;

        confirmation.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
}
